import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import classnames from "classnames";
import SingleBoxShadow from "./boxshadow/singleboxshadow";
import ResetState from "./resetstate";

function BoxShadowInput({
  value,
  onChange,
  className,
  resetValue,
  isResetVisible = true,
  maxShadows,
  hideSpread,
  label = "Box Shadows",
}) {
  const handleDelete = (index) => {
    const oldValues = [...(value ? value : [])];
    oldValues.splice(index, 1);
    onChange(oldValues);
  };

  const addNewShadow = () => {
    if (value && maxShadows && value.length >= maxShadows) return;
    const oldValues = [
      ...(value ? value : []),
      {
        x: "0px",
        y: "7px",
        blur: "0px",
        spread: "29px",
        color: "rgba(100, 100, 100, 0.2)",
      },
    ];
    onChange(oldValues);
  };
  const classes = classnames(
    "grigora-boxshadow text-grigora-base cursor-default border rounded-[6px]",
    className,
  );
  return (
    <div className={classes}>
      <div className="grigora-boxshadow__title p-2 items-center flex justify-between">
        <span> {label}</span>
        <div className="flex items-center gap-2">
          {isResetVisible && (
            <ResetState
              active={value !== resetValue}
              onClick={() => {
                onChange(resetValue);
              }}
            />
          )}
          <FontAwesomeIcon
            onClick={addNewShadow}
            icon={faPlus}
            className="grid p-2 cursor-pointer"
          />
        </div>
      </div>
      <div className="grigora-boxshadow__items">
        {value &&
          Array.isArray(value) &&
          value.map((item, index) => {
            return (
              <SingleBoxShadow
                hideSpread={hideSpread}
                onDelete={() => {
                  handleDelete(index);
                }}
                key={index}
                value={item}
                index={index}
                onChange={(e) => {
                  var temp = [...(value ? value : [])];
                  temp[index] = e;
                  onChange(temp);
                }}
              />
            );
          })}
      </div>
    </div>
  );
}
export default BoxShadowInput;
